import { DB_Object_validator, tsValidateArray, tsValidateBoolean, tsValidateNonMandatoryObject, tsValidateOptional, tsValidateOptionalId, tsValidateUniqueId } from '@nu-art/ts-common';
import { getExpressionValidator } from './validator.js';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_GeneratedProps = {
    ...DB_Object_validator,
    _originId: tsValidateOptionalId,
    _isDraft: tsValidateBoolean(false),
    _refs: tsValidateNonMandatoryObject({
        _variableIds: tsValidateArray(tsValidateUniqueId, true, 0),
        _valueIds: tsValidateArray(tsValidateUniqueId, true, 0),
        _exprIds: tsValidateArray(tsValidateUniqueId, true, 0),
    }),
    _schema_expression: tsValidateOptional,
    _tagIds: tsValidateArray(tsValidateUniqueId)
};
export const DBDef_Expression = {
    modifiablePropsValidator: getExpressionValidator(),
    generatedPropsValidator: Validator_GeneratedProps,
    generatedProps: ['_originId', '_refs', '_isDraft', '_schema_expression', '_tagIds'],
    versions: ['1.0.11', '1.0.10', '1.0.9', '1.0.8', '1.0.7', '1.0.6', '1.0.5', '1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'expressions',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'expressions'
    },
    backend: {
        name: 'expressions'
    },
    entityName: 'Expression',
    dependencies: {
        '_refs._variableIds': {
            dbKey: 'variables',
            fieldType: 'string[]'
        },
        '_refs._valueIds': {
            dbKey: 'values',
            fieldType: 'string[]'
        },
        '_refs._exprIds': {
            dbKey: 'expressions',
            fieldType: 'string[]'
        },
        '_tagIds': {
            dbKey: 'tags',
            fieldType: 'string[]'
        }
    }
};
//# sourceMappingURL=db-def.js.map